(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babel-runtime/helpers/typeof"), require("babel-runtime/helpers/classCallCheck"), require("babel-runtime/helpers/createClass"), require("babel-runtime/helpers/possibleConstructorReturn"), require("babel-runtime/helpers/inherits"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["babel-runtime/helpers/typeof", "babel-runtime/helpers/classCallCheck", "babel-runtime/helpers/createClass", "babel-runtime/helpers/possibleConstructorReturn", "babel-runtime/helpers/inherits", "react"], factory);
	else if(typeof exports === 'object')
		exports["Webcam"] = factory(require("babel-runtime/helpers/typeof"), require("babel-runtime/helpers/classCallCheck"), require("babel-runtime/helpers/createClass"), require("babel-runtime/helpers/possibleConstructorReturn"), require("babel-runtime/helpers/inherits"), require("react"));
	else
		root["Webcam"] = factory(root["babel-runtime/helpers/typeof"], root["babel-runtime/helpers/classCallCheck"], root["babel-runtime/helpers/createClass"], root["babel-runtime/helpers/possibleConstructorReturn"], root["babel-runtime/helpers/inherits"], root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(1);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(4);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(5);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _video = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Deliberately ignoring the old api, due to very inconsistent behaviour
*/
var mediaDevices = navigator.mediaDevices;
var getUserMedia = mediaDevices && mediaDevices.getUserMedia ? mediaDevices.getUserMedia.bind(mediaDevices) : null;
var hasGetUserMedia = !!getUserMedia;

var DEBUG = false;
var debugConsole = function debugConsole() {
  var _console;

  if (DEBUG) (_console = console).log.apply(_console, arguments);
};

var permissionErrors = ['PermissionDeniedError', 'NotAllowedError', 'NotFoundError'];

var Webcam = function (_Component) {
  (0, _inherits3.default)(Webcam, _Component);

  function Webcam(props) {
    (0, _classCallCheck3.default)(this, Webcam);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Webcam.__proto__ || Object.getPrototypeOf(Webcam)).call(this, props));

    _this.state = {
      hasUserMedia: false,
      mirrored: false
    };


    if (!hasGetUserMedia) {
      var error = new Error('getUserMedia is not supported by this browser');
      _this.props.onFailure(error);
    }
    return _this;
  }

  (0, _createClass3.default)(Webcam, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Webcam.mountedInstances.push(this);
      this.requestUserMedia();
    }
  }, {
    key: 'getConstraints',
    value: function getConstraints(width, height, facingMode, audio) {
      /*
      Safari 11 has a bug where if you specify both the height and width
      constraints you must chose a resolution supported by the web cam. If an
      unsupported resolution is used getUserMedia(constraints) will hit a
      OverconstrainedError complaining that width is an invalid constraint.
      This bug exists for ideal constraints as well as min and max.
       However if only a height is specified safari will correctly chose the
      nearest resolution supported by the web cam.
       Reference: https://developer.mozilla.org/en-US/docs/Web/API/Media_Streams_API/Constraints
      */

      // if `{facingMode: 'user'}` Firefox will still allow the user to choose which camera to use (Front camera will be the first option)
      var constraints = { video: { facingMode: facingMode }, audio: audio };

      if (width) {
        constraints.video.width = parseInt(width, 10) || width; // some devices need a Number type
      }

      if (height) {
        constraints.video.height = parseInt(height, 10) || height;
      }

      return constraints;
    }
  }, {
    key: 'requestUserMedia',
    value: function requestUserMedia() {
      if (!getUserMedia || !mediaDevices) return;
      var _props = this.props,
          width = _props.width,
          height = _props.height,
          facingMode = _props.facingMode,
          audio = _props.audio,
          fallbackWidth = _props.fallbackWidth,
          fallbackHeight = _props.fallbackHeight;


      var constraints = this.getConstraints(width, height, facingMode, audio);
      var fallbackConstraints = this.getConstraints(fallbackWidth, fallbackHeight, facingMode, audio);

      var logError = function logError(e) {
        return console.log('error', e, typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e));
      };

      var onSuccess = function onSuccess(stream) {
        Webcam.mountedInstances.forEach(function (instance) {
          return instance.handleUserMedia(stream);
        });
      };

      var hasTriedFallbackConstraints = void 0;
      var onError = function onError(e) {
        logError(e);
        var isPermissionError = permissionErrors.includes(e.name);
        if (isPermissionError || hasTriedFallbackConstraints) {
          Webcam.mountedInstances.forEach(function (instance) {
            return instance.handleError(e);
          });
        } else {
          hasTriedFallbackConstraints = true;
          getUserMedia(fallbackConstraints).then(onSuccess).catch(onError);
        }
      };
      getUserMedia(constraints).then(onSuccess).catch(onError);
    }
  }, {
    key: 'handleError',
    value: function handleError(error) {
      this.setState({
        hasUserMedia: false
      });
      this.props.onFailure(error);
    }
  }, {
    key: 'handleUserMedia',
    value: function handleUserMedia(stream) {
      this.stream = stream;
      var videoSettings = stream.getVideoTracks()[0].getSettings();
      debugConsole('video track settings', videoSettings);
      this.setState({
        hasUserMedia: true,
        mirrored: videoSettings.facingMode === 'user'
        /* #HACK desktop cameras seem to have `facingMode` undefined,
        therefore we are assuming all desktop cameras are user facing*/
        || !videoSettings.facingMode
      });

      this.props.onUserMedia();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var index = Webcam.mountedInstances.indexOf(this);
      Webcam.mountedInstances.splice(index, 1);

      if (Webcam.mountedInstances.length === 0 && this.state.hasUserMedia) {
        if (this.stream.getVideoTracks) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = this.stream.getVideoTracks()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var track = _step.value;

              track.stop();
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }
        if (this.stream.getAudioTracks) {
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = this.stream.getAudioTracks()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var _track = _step2.value;

              _track.stop();
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      }
    }
  }, {
    key: 'getScreenshot',
    value: function getScreenshot() {
      var canvas = this.getCanvas();
      if (!canvas) return null;
      return canvas.toDataURL(this.props.screenshotFormat);
    }
  }, {
    key: 'getCanvas',
    value: function getCanvas() {
      if (!this.state.hasUserMedia || !this.video) return null;

      var video = this.video;

      if (!this.canvas) this.canvas = document.createElement('canvas');
      var canvas = this.canvas;


      if (!this.ctx) this.ctx = canvas.getContext('2d');
      var ctx = this.ctx;

      // This is set every time incase the video element has resized

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      debugConsole('drawn image to canvas: ' + canvas.width + 'x' + canvas.height);
      return canvas;
    }
  }, {
    key: 'startRecording',
    value: function startRecording() {
      this.mediaRecorder = (0, _video.createMediaRecorder)(this.stream);
      this.recordedBlobs = (0, _video.startRecording)(this.mediaRecorder);
    }
  }, {
    key: 'stopRecording',
    value: function stopRecording() {
      this.mediaRecorder.stop(this.recordedBlobs);
    }
  }, {
    key: 'getVideoBlob',
    value: function getVideoBlob() {
      var mimeType = this.mediaRecorder.mimeType;
      var type = mimeType.split(';')[0]; // mimeType (excluding the codec)
      return new Blob(this.recordedBlobs, { type: type });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('video', {
        style: {
          // not necessary to add prefixes, since all browsers that support camera
          // support transform
          transform: this.state.mirrored ? 'scaleX(-1)' : ''
        },
        ref: function ref(el) {
          return _this2.video = el;
        },
        autoPlay: true,
        playsinline: true // necessary for iOS, see https://github.com/webrtc/samples/issues/929
        , srcObject: this.stream,
        muted: true // muted must be true for recording videos
        , className: this.props.className
      });
    }
  }]);
  return Webcam;
}(_react.Component);

Webcam.defaultProps = {
  audio: false,
  screenshotFormat: 'image/webp',
  onUserMedia: function onUserMedia() {},
  onFailure: function onFailure() {}
};
Webcam.mountedInstances = [];
exports.default = Webcam;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MediaRecorder = window.MediaRecorder;

var handleDataAvailable = function handleDataAvailable(event, recordedBlobs) {
  if (event.data && event.data.size > 0) {
    recordedBlobs.push(event.data);
  }
};

var handleStop = function handleStop(event) {
  console.log('Recorder stopped: ', event);
};

var videoOptions = function videoOptions() {
  var mimeTypes = ['video/webm;codecs=vp9', 'video/webm;codecs=vp8', 'video/webm'];
  var mimeType = '';
  for (var type in mimeTypes) {
    if (MediaRecorder.isTypeSupported(mimeTypes[type])) {
      mimeType = mimeTypes[type];
      break;
    } else {
      console.log(mimeTypes[type] + ' is not Supported');
    }
  }
  return mimeType ? { mimeType: mimeType } : { mimeType: '' };
};

var createMediaRecorder = exports.createMediaRecorder = function createMediaRecorder(stream) {
  var options = videoOptions();
  try {
    return new MediaRecorder(stream, options);
  } catch (e) {
    console.error('Exception while creating MediaRecorder: ' + e);
    return;
  }
};

var startRecording = exports.startRecording = function startRecording(mediaRecorder) {
  var recordedBlobs = [];
  mediaRecorder.onstop = handleStop;
  mediaRecorder.ondataavailable = function (e) {
    return handleDataAvailable(e, recordedBlobs);
  };
  mediaRecorder.start(10); // collect 10ms of data
  console.log('MediaRecorder started', mediaRecorder);
  return recordedBlobs;
};

/***/ })
/******/ ]);
});


//////////////////
// WEBPACK FOOTER
// ../~/react-webcam-onfido/dist/react-webcam.js
// module id = 381
// module chunks = 1